/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
import schema_properties from '@bingads-webui-component-legacy/grid/schema/properties';
import Response from '@bingads-webui-component-legacy/grid/model/response';
var Model = BaseProjection.extend({
  defaults: {
    map: function (i) {
      return i;
    }
  },
  name: 'map',
  update: function (options) {
    if (Model.__super__.update.call(this, options)) {
      var model = this.src.data, map = this.get('map'), value = _.isFunction(map) ? _.map(model.get('value'), map) : model.get('value');
      value = _.flatten(value);
      this.patch({
        value: value,
        select: schema_properties.from(value)
      });
    } else {}
  }
});
export default Model;

